/** User-facing toast for a project fetch error. */
export interface ProjectErrorToast {
  title: string;
  description: string;
}

/** Map error message to a user-friendly toast. */
export function getProjectErrorToast(errorMessage: string): ProjectErrorToast {
  const lower = errorMessage.toLowerCase();
  if (lower.includes('not_connected')) {
    return {
      title: 'Not Connected',
      description: 'Please connect your Google Cloud account first.',
    };
  }
  if (lower.includes('api_permission_denied')) {
    return {
      title: 'Permission Denied',
      description: 'Please ensure you have granted the required permissions.',
    };
  }
  if (lower.includes('api_not_enabled')) {
    return {
      title: 'API Not Enabled',
      description: 'Cloud Resource Manager API is not enabled. Please enable it in GCP Console.',
    };
  }
  return {
    title: 'Error',
    description: errorMessage,
  };
}
